import { Link, useNavigate, useParams } from "react-router-dom";
import { IMAGE_DNS } from "../../../utils/config/Config";
import { useState, useEffect } from "react";
import {
  cameraToggleState,
  contentsValueState,
  editCommentNumState,
  imgBase64State,
  imgFileState,
  isEditState,
  isProfilePageState,
  parentsIdxState,
  popContValueState,
  popState
} from "../../../recoil/contentsAtom";
import { useRecoilValue, useRecoilState, useSetRecoilState } from "recoil";
import WrapLoading from "../../common/loading/WrapLoading";
import { useTranslation } from "react-i18next";
import {
  getBeforeComment,
  usePostContentsMutation,
  usePutContentsMutation
} from "../../../api/popPageCommentsApi";
import Emoji from "../common/Emoji";
import {
  contentsCheck,
  emptyContentCheck
} from "../common/popPageCommonFunc/CommonFunc";
import PopPageBtns from "../common/popPageUI/PopPageBtns";
import PopPagePhotos from "../common/popPageUI/PopPagePhotos";
import PopPageContents from "../common/popPageUI/PopPageContents";
import {
  headersState,
  userInfoState,
  userNicknameState,
  userProfileImgState,
  userProfileKeyState
} from "../../../recoil/userInfoAtom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import { BASE_PATH, CommentData } from "api/commonApi";
import {
  emptyContentCheckTKey,
  imgsSizeTkey,
  imgsTypeTkey,
  imgsLenTkey
} from "utils/CommonTranslationKey";

function PopPageComments() {
  const { t } = useTranslation();
  const { idx, profilekey } = useParams();
  const userInfo = useRecoilValue(userInfoState);
  const headers = useRecoilValue(headersState);
  const userNickname = useRecoilValue(userNicknameState);
  const editCommentNum = useRecoilValue(editCommentNumState);
  const [popContValue, setPopContValue] = useRecoilState(popContValueState);
  const [parentsIdx, setParentsIdx] = useRecoilState(parentsIdxState);
  const [popOpen, setPopOpen] = useRecoilState(popState);
  const [imgFile, setImgFile] = useRecoilState(imgFileState);
  const [isEdit, setIsEdit] = useRecoilState(isEditState);
  const [isLoading, setIsLoading] = useState(false);
  const setContentsValue = useSetRecoilState(contentsValueState);
  const setImgBase64 = useSetRecoilState(imgBase64State);
  const [cameraToggle, setCameraToggle] = useRecoilState(cameraToggleState);
  const isProfilePage = useRecoilValue(isProfilePageState);
  const userProfileKey = useRecoilValue(userProfileKeyState);
  const userProfileImg = useRecoilValue(userProfileImgState);
  const navigate = useNavigate();
  let postValue: any = {};

  // 공통
  const commentsReset = () => {
    setPopContValue({ title: "", content: "" });
    setContentsValue("");
    setIsEdit(false);
    setImgBase64([]);
    setImgFile(null);
    setCameraToggle(false);
    setPopOpen(false);
  };

  useEffect(() => {
    setCameraToggle(false);
  }, [popOpen]);

  const contentsCheckProps = {
    imgFile,
    imgsSizeTkey,
    imgsTypeTkey,
    imgsLenTkey,
    t
  };

  const closeModal = () => {
    commentsReset();
  };

  //// data submit
  const formData = new FormData();

  //// 댓글 쓰기
  const { mutate: postMutate } = usePostContentsMutation(
    isProfilePage ? "profile_comments_board_list" : "comments_board_list"
  );

  const postApi = `${BASE_PATH}/${
    isProfilePage
      ? `api/vfunlounge/profile/post/comment`
      : `api/vfunlounge/comments/${idx}`
  }`;

  const commentsSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (emptyContentCheck(t(emptyContentCheckTKey), popContValue.content)) {
      if (imgFile !== null && imgFile !== undefined && imgFile.length !== 0) {
        // 댓글과 사진
        if (contentsCheck(contentsCheckProps)) {
          Object.values(imgFile).forEach((file: any) =>
            formData.append("images[]", file)
          );
        }
      }

      formData.append("comment_idx", parentsIdx.toString());
      formData.append("comment", popContValue.content);

      if (isProfilePage) {
        formData.append("user_profile_key", profilekey || "");
        formData.append("board_idx", idx || "0");
      }

      postValue = formData;
      const props = { postApi, postValue, headers };
      setIsLoading(true);

      postMutate(props, {
        onSuccess: (api) => {
          if (api.data.result === 1) {
            setIsLoading(false);
            commentsReset();
            setParentsIdx(0);
          } else if (api.data.result === -88) {
            setPopOpen(false);
            alert(
              "존재하지 않은 프로필 유저입니다. 프로필 생성 후 이용해주세요"
            );
            navigate(`/profile/${userProfileKey}`);
          }
          setIsLoading(false);
        },
        onError: (error: any) => {
          alert(t(error.response.data.message));
          setIsLoading(false);
        }
      });
    }
  };

  //// 댓글 수정하기
  // 이전 댓글 내용 가져오기
  const getApi = isProfilePage
    ? `${BASE_PATH}/api/vfunlounge/profile/post/comment/${idx}/${editCommentNum}`
    : `${BASE_PATH}/api/vfunlounge/comments/${idx}/${editCommentNum}`;

  useEffect(() => {
    if (isEdit) {
      const props = { headers, idx, getApi };
      getBeforeComment(props).then(
        (res: { result: number; data: CommentData }) => {
          if (res.result === 1) {
            if (res.data.idx === editCommentNum) {
              setContentsValue(res.data.comment);
              setPopContValue({
                ...popContValue,
                content: res.data.comment
              });
              const beforeImage = res.data.images;
              setCameraToggle(beforeImage === null ? false : true);
              setImgBase64(res.data.images);
            }
          }
        }
      );
    }
  }, [editCommentNum, isEdit]);

  //// 수정하기
  const { mutate: putMutate } = usePutContentsMutation(
    isProfilePage ? "profile_comments_board_list" : "comments_board_list"
  );

  const putApi = isProfilePage
    ? `${BASE_PATH}/api/vfunlounge/profile/post/comment`
    : `${BASE_PATH}/api/vfunlounge/comments/${String(editCommentNum)}`;

  const editSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (emptyContentCheck(emptyContentCheckTKey, popContValue.content)) {
      if (imgFile !== null && imgFile !== undefined && imgFile.length !== 0) {
        if (contentsCheck(contentsCheckProps)) {
          Object.values(imgFile).forEach((file: any) =>
            formData.append("images[]", file)
          );
        } else return;
      }

      formData.append("comment", popContValue.content);
      formData.append("_method", "PUT");
      formData.append("deleteimg", cameraToggle ? "0" : "1");

      if (isProfilePage) {
        formData.append("board_idx", idx || "0");
        formData.append("comment_idx", String(editCommentNum));
      }

      postValue = formData;
      const props = { putApi, postValue, headers };
      setIsLoading(true);

      putMutate(props, {
        onSuccess: (api) => {
          if (api.data.result === 1) {
            commentsReset();
          }
          setIsLoading(false);
        },
        onError: (error: any) => {
          alert(t(error.response.data.message));
          setIsLoading(false);
        }
      });
    }
  };

  return isLoading ? (
    <WrapLoading />
  ) : (
    <div
      className="layer-wrap article-type"
      style={{ top: popOpen === true ? "1vh" : "100%" }}
    >
      <div className={popOpen === true ? "shadow" : ""} />
      <form
        className="pop-layer"
        onSubmit={!isEdit ? commentsSubmit : editSubmit}
      >
        {/* 팝업 상단 */}
        <h1 className="clearfix popUp-top">
          {!isEdit ? t("write_a_comment") : t("edit_comment")}
          <Link className="btn-layer-close" to="#" onClick={closeModal}>
            <FontAwesomeIcon icon={faCircleXmark} />
          </Link>
        </h1>

        <div className="pop-container animationOn">
          <h2 className="skip">VFUN 메세지</h2>
          <div className="frame">
            <div className="alert">
              <div className="info clearfix">
                <img
                  className="user-pic"
                  src={
                    userProfileImg.length !== 0
                      ? userProfileImg
                      : IMAGE_DNS +
                        "/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
                  }
                  alt="프로필 - 디폴트"
                />
                <span className="nickname">
                  {userNickname === "" ? userInfo.Userid : userNickname}
                </span>
              </div>
              {/* 내용 */}
              <PopPageContents type="comments" />
            </div>
          </div>
          {/* 사진 버튼과 이모지 버튼 */}
          <PopPageBtns writeType="comments" />
          {/* 사진 */}
          <PopPagePhotos />
        </div>

        {/* 버튼 */}
        <div className="btn-wrap long">
          <button className="btn-post">
            {!isEdit ? t("Post") : t("edit")}
          </button>
        </div>

        {/* 이모지 리스트 */}
        <Emoji />
      </form>
    </div>
  );
}

export default PopPageComments;
